import { getPremiumEssentials } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { EntriModule, ModalsModule } from '../../../../ModalsExtensions';
import { fetchWithFallback } from '@wix/premium-fed-sdk/@apis-infra';
import { entriConnectAction } from '../../entriConnectAction';
import { EntriFlowStatus, parseDomain } from '@wix/domains-serverless-interface';
export const domainIsTakenHandler = async _ref => {
  let domainName = _ref.domainName,
    msid = _ref.msid,
    siteName = _ref.siteName,
    externalViewer = _ref.externalViewer,
    fullPage = _ref.fullPage,
    t = _ref.t;
  const _parseDomain = parseDomain(domainName),
    main = _parseDomain.main;
  const _getPremiumEssentials = getPremiumEssentials(),
    httpClient = _getPremiumEssentials.httpClient;
  const canChangeOwnerReq = fetchWithFallback(DomainsApiClient.query.canChangeDomainOwner({
    httpClient: httpClient,
    request: {
      domain: main
    }
  }), {
    canChangeOwner: false
  });
  const loaderModal = ModalsModule.internals.domainsSharedModalsController.loaderModal;
  loaderModal.show({});
  const _await$canChangeOwner = await canChangeOwnerReq,
    canChangeOwner = _await$canChangeOwner.canChangeOwner;
  const domainTakenInWixEntri = await DomainsApiClient.query.domainTakenInAnotherAccountEntriEligibility({
    httpClient: httpClient,
    request: {
      domain: main
    }
  });
  loaderModal.hide();
  if (domainTakenInWixEntri.isEligible) {
    const entriCallback = async () => {
      return entriConnectAction({
        domainName: main,
        msid,
        siteName: siteName ?? '',
        overrideEntriEligibility: domainTakenInWixEntri,
        isNonWixEditorSite: externalViewer,
        fullPage,
        t
      });
    };
    const result = await entriCallback();
    switch (result.status) {
      case EntriFlowStatus.manual:
        EntriModule.internals.domainsEntriModalsController.domainTakenInWixEntriModal.show({
          connectHandler: async () => {
            await entriCallback();
          }
        });
        // undefined keeps the caller on the modal instead of the manual connect flow
        return undefined;
    }
    return result.status;
  }
  if (canChangeOwner) {
    return EntriFlowStatus.manual;
  }
  loaderModal.hide();
  ModalsModule.internals.domainsActionsModalsController.domainTakenInWix.show({
    domain: domainName
  });
  return undefined;
};
//# sourceMappingURL=DomainIsTakenHandler.js.map